import { addTool } from '@cornerstonejs/tools';
import GleamerPredictionRectangleTool from './tools/GleamerPredictionRectangleTool';
import GleamerPredictionContourTool from './tools/GleamerPredictionContourTool';

export function init() {
  addTool(GleamerPredictionRectangleTool);
  addTool(GleamerPredictionContourTool);
}
